import * as React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { hasPermissionTo } from 'helpers/permission-helper';
import { Permission } from 'types/permission';
import { Mode } from 'types/mode';
import { translations } from 'types/translations';
import { LanguageCode } from 'types/tenants/language-code';

import './styles.css';

export interface ConnectedProps {
  permissions: string;
  language?: LanguageCode;
}

export interface ActionProps {
  clearList?: () => void;
}

export type Props = ConnectedProps & ActionProps;

export const ClearList: React.StatelessComponent<Props> = (props) => {
  const i18n = getI18n();

  const canClearList: boolean = hasPermissionTo([Mode.Read], Permission.ClearList, props.permissions);

  const button = canClearList
    ? (
      <Button
        icon={true}
        labelPosition="right"
        className="clear-list-button neutral-dark"
        onClick={props.clearList}>
          <Icon name="close" />
          {i18n.t(translations.ClearCompleted)}
      </Button>
    )
    : null;

  return button;
};



// WEBPACK FOOTER //
// ./src/components/clear-list/component.tsx